import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { BulkExportButton, BulkDeleteButton } from "react-admin";
export const ListBulkActions = () => (_jsxs(_Fragment, { children: [_jsx(BulkExportButton, {}), _jsx(BulkDeleteButton, {})] }));
